import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

export interface IDropOption {
  title: string;
  id: any;
  extra?: string;
}

import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import {
  FormControl,
  FormControlName,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-phil-dropdown',
  imports: [MatAutocompleteModule, ReactiveFormsModule],
  templateUrl: './phil-dropdown.component.html',
  styleUrls: ['./phil-dropdown.component.scss'],
  standalone: true,
})
export class PhilDropdownComponent {
  @Input() options!: IDropOption[]; // options to show in dropdown
  @Input() control?: FormControl; // form control if available
  @Input() placeholder: string = ''; // placeholder text to be shown in the input box

  @Input() isSelectEmit: boolean = false; // emits an event on select if its true
  @Output() optionSelected = new EventEmitter<string>(); // the  event emitter on select
  @Input() isSelectEmitTitle: boolean = false; // if set true emit the selected title as well
  @Output() titleSelected = new EventEmitter<string>(); // the event emitter for title on select
  @Input() isKeyUp: boolean = false; // set it true if you want to emit an event on key up
  @Output() onKeyUp = new EventEmitter<KeyboardEvent>(); // event emitter for key up

  @Input() isAutoFocus: boolean = false; // if set true sets autofocus on input on loading
  @Input() isInputTextControl: boolean = false; // if set true it acts just like a input control

  @Input() isNotEditable: boolean = false; // set it true if you want to make the input field non editable
  @Input() showError: boolean = false; // if set true shows the error message
  @Input() errorMessage!: string; // error message to be set
  @Input() isTransparent: boolean = false; // if set true makes the dropdown input transparent

  @Output() optionClicked = new EventEmitter<string>();

  tempOptions: any;
  filteredOptions: any = [];
  isError: boolean = false;

  constructor() {}

  ngOnInit() {
    if (!this.isInputTextControl) {
      this.control?.valueChanges.subscribe((data) => {
        const selected = this.options.find(
          (opt) => String(opt.id).toLowerCase() === String(data).toLowerCase()
        );
        if (selected) this.inputElement.nativeElement.value = selected?.title;
        else this.inputElement.nativeElement.value = '';
      });
    }
    this.filteredOptions = this.options;
  }

  // triggers when options are changed
  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.filteredOptions = changes['options'].currentValue;

      // Preselect value if control already has a value
      if (this.control?.value) {
        const selected = this.options.find(
          (opt) =>
            String(opt.id).toLowerCase() ===
            String(this.control?.value).toLowerCase()
        );
        if (this.inputElement?.nativeElement) {
          if (selected) {
            this.inputElement.nativeElement.value = selected.title;
          } else {
            this.inputElement.nativeElement.value = '';
          }
        }
      }
    }
  }

  @ViewChild('dropInput') inputElement!: ElementRef;

  ngAfterViewInit() {
    if (this.isAutoFocus)
      setTimeout(() => this.inputElement.nativeElement.focus()); // set auto focus to the input if autofocus in turned on
    if (this.control?.value) {
      const selected = this.options?.find(
        (opt) =>
          String(opt.id).toLowerCase() ===
          String(this.control?.value).toLowerCase()
      );
      if (selected) this.inputElement.nativeElement.value = selected?.title; // if value already set in form control, set its title in the input box
    }
  }

  filterOptions(val: string | null) {
    if (!this.isInputTextControl) {
      if (val && val.length > 0) {
        this.filteredOptions = this.options.filter((opt) =>
          opt.title.toLowerCase().includes(val.toLowerCase())
        );
      } else {
        this.filteredOptions = this.options;
        if (this.isSelectEmit) {
          this.optionSelected.emit(''); // if isSelectEmit emit the null/empty string value to @Output optionSelected
        }
        if (this.control) {
          this.control.setValue(''); // clear the selected form control when value is cleared
        }
      }
    }
  }

  onSelect(event: MatAutocompleteSelectedEvent) {
    if (this.isSelectEmit) {
      const selected = this.options.find(
        (opt) =>
          String(opt.title).toLowerCase() ===
          String(event.option.value).toLowerCase()
      );
      this.optionSelected.emit(selected?.id);
    }
    if (this.isSelectEmitTitle) {
      const title = event.option.value;
      this.titleSelected.emit(title);
    }
    if (this.isSelectEmit && !this.isInputTextControl)
      if (this.control) {
        const selectedOption = this.options.find(
          (opt) =>
            String(opt.title).toLowerCase() ===
            String(event.option.value).toLowerCase()
        );
        this.control.setValue(selectedOption?.id);
      }
  }

  onClick(id: string) {
    this.optionClicked.emit(id);
  }

  getFormControl() {
    return this.control as FormControl;
  }

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger!: MatAutocompleteTrigger;
  openFocus() {
    if (!this.isNotEditable) this.autocompleteTrigger.openPanel();
  }

  closeFocus() {
    this.autocompleteTrigger.closePanel();
  }

  onClickKeyUp(event: KeyboardEvent) {
    if (this.isKeyUp) this.onKeyUp.emit(event);
  }

  checkValid() {
    if (!this.control?.valid) this.isError = true;
    else if (!this.control.value) this.isError = true;
    else this.isError = false;
  }
}
